<template>
  <LikeIcon v-if="isType('like')" :color="color ? color : 'white'" size="15" style="margin-bottom:-1px"></LikeIcon>
  <RncIcon v-else-if="isType('rnc')" :color="color ? color : 'white'" size="20" style="margin-bottom:-1px"></RncIcon>
  <OssIson v-else-if="isType('oss')" :color="color ? color : 'white'" size="15" style="margin-bottom:-1px"></OssIson>
  <FireIcon v-else-if="isType('fire')" :color="color ? color : 'white'" size="15" style="margin-bottom:-1px"></FireIcon>
  <MatchIcon v-else-if="isType('saved_competitor_alert')" :color="color ? color : 'white'" size="20"
    style="margin-bottom:-1px"></MatchIcon>
  <v-icon v-else :color="themeColor('accent')" size="15">{{ materialIcon() }}</v-icon>
</template>

<script>
import LikeIcon from "@/components/displays/icons/IconLike.vue";
import OssIson from "@/components/displays/icons/IconOss.vue";
import FireIcon from "@/components/displays/icons/IconFire.vue";
import RncIcon from "@/components/displays/icons/IconRnc.vue";
import MatchIcon from "@/components/displays/icons/IconMatch.vue";

export default {
  components: {
    LikeIcon,
    RncIcon,
    FireIcon,
    OssIson,
    MatchIcon,
  },
  props: ["type"],
  data() {
    return {
      color: 'white',
    };
  },
  created(){
    this.colorMe();
  },
  methods:{
    isType(t){
      if(this.type && (this.type == t || this.type.indexOf(t) >= 0))
        return true;
      else
        return false;
    },
    // Only "oss" and "like" keep their own distinct color — every other icon (including the
    // other manually-created ones: rnc, fire, saved_competitor_alert) uses the shared accent
    // color to keep this simple instead of juggling a color per type.
    colorMe(){
      const t = this.type;
      if(t && t.indexOf('like') >= 0){
        this.color = this.themeColor('blue');
      } else if(t == this.notificationTypes.POSTOSS){
        this.color = this.themeColor('error');
      } else {
        this.color = this.themeColor('accent');
      }
    },
    materialIcon() {
      if (this.isType('class') || this.isType('event') || this.isType('new_academy_visitor'))
        return 'mdi-calendar-outline';
      if (this.isType('new_academy_inquiry')) return 'mdi-pencil-outline';
      if (this.isType('new_academy_member')) return 'mdi-home-outline';
      if (this.isType('comment')) return 'mdi-comment-text-outline';
      if (this.isType('academy_message')) return 'mdi-chat-outline';
      if (this.isType('payment')) return 'mdi-cash';
      if (this.isType('belt_verified') || this.isType('ibjjf_claim_approved'))
        return 'mdi-check-decagram';
      if (this.isType('belt_rejected') || this.isType('ibjjf_claim_rejected'))
        return 'mdi-close-circle-outline';
      if (this.isType('video')) return 'mdi-video-outline';
      if (this.isType('new_link')) return 'mdi-link-variant';
      if (this.isType('document_signature_request') || this.isType('document_survey_request'))
        return 'mdi-file-document-outline';
      if (this.isType('academy_reviewed')) return 'mdi-star-outline';
      if (this.isType('post_tag')) return 'mdi-tag-outline';
      if (this.isType('program_assigned')) return 'mdi-school-outline';
      if (this.isType('academy_post')) return 'mdi-pin-outline';
      return 'mdi-bell-outline';
    },
  }
};
</script>

<style scoped>
</style>
